import fetchStations from "../fetchStations";

import SearchEngine from "./SearchEngine";
import { SearchResultType } from "./types";

import type { Store } from "redux";

import type { SearchEngineSearchOptions, SearchResult } from "./types";

export interface StopFeature {
  geometry: { coordinates: [number, number]; type: "Point" };
  properties: {
    country_code: string;
    id?: number | string;
    mot?: Record<string, boolean>;
    municipality_name: string;
    name: string;
  };
}

export interface StopsSearchEngineOptions {
  params?: Record<string, unknown>;
  priority?: number;
  store: Store;
  /** Filter applied on the raw features, kept for the StopFinder api. */
  suggestionsFilter?: (_feature: StopFeature) => boolean;
}

/**
 * Search engine querying the geOps stops api.
 */
class StopsSearchEngine extends SearchEngine<StopFeature> {
  readonly id = "stops";

  readonly placeholderLabels = ["Haltestelle"];

  private readonly params: Record<string, unknown>;

  private readonly store: Store;

  private readonly suggestionsFilter: (_feature: StopFeature) => boolean;

  constructor({
    params = {},
    priority = 0,
    store,
    suggestionsFilter = () => {
      return true;
    },
  }: StopsSearchEngineOptions) {
    super({ priority });
    this.store = store;
    this.params = params;
    this.suggestionsFilter = suggestionsFilter;
  }

  protected async doSearch(
    query: string,
    { signal }: SearchEngineSearchOptions,
  ): Promise<SearchResult<StopFeature>[]> {
    const data = await fetchStations(
      this.store,
      { q: query, ...this.params },
      { signal },
    );
    if (data.error) {
      throw new Error(data.error);
    }
    return ((data.features || []) as StopFeature[])
      .filter(this.suggestionsFilter)
      .map((feature, index) => {
        const {
          country_code: countryCode,
          id,
          mot,
          municipality_name: municipality,
          name,
        } = feature.properties || {};
        return {
          feature,
          geometry: feature.geometry,
          id: `stop-${id != null ? id : index}`,
          label: name,
          rank: index,
          subtitle: `${municipality} (${countryCode})${mot?.rail && id ? ` - ${id}` : ""}`,
          type: SearchResultType.STOP,
        };
      });
  }
}

export default StopsSearchEngine;
